
export const AccountTypeEnums = {
  IDENTITY_CARD: 'IDENTITY_CARD',
  UNIFORM_NUMBERS: 'UNIFORM_NUMBERS',
  PASSPORT: 'PASSPORT',
  CHINA_ID_CARD: 'CHINA_ID_CARD'
  // OTHER: 'OTHER'
}

export const AccountTypeMap = {
  [AccountTypeEnums.IDENTITY_CARD]: '身分證',
  [AccountTypeEnums.UNIFORM_NUMBERS]: '統編',
  [AccountTypeEnums.PASSPORT]: '護照',
  [AccountTypeEnums.CHINA_ID_CARD]: '大陸身份證'
  // [AccountTypeEnums.OTHER]: '其他'
}

export function formatDate(date, fmt) {
  date = new Date(date)
  if (typeof (fmt) === 'undefined') {
    fmt = 'yyyy-MM-dd HH:mm:ss'
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'H+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      const str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : ('00' + str).substr(str.length))
    }
  }
  return fmt
}
